<template>
  <el-submenu index="download-menu" popper-append-to-body>
     <template slot="title"><i class="el-icon-download"/></template>
      <el-menu-item index="mep-guideline">
         <a href="/media/downloads/MEPGuidelines.pdf" download="MEPGuidelines.pdf">
            MEP Guidelines
         </a>
      </el-menu-item>
      <el-menu-item index="user-manual">
         <a href="/media/downloads/MEPUserManual.pdf" download="MEPUserManual.pdf">
            User Manual
         </a>
      </el-menu-item>
      <el-menu-item index="energy-data" :disabled="!getEnergyCSVURI || !isDashboardMode">
         <a
            v-if="isDashboardMode && getEnergyCSVURI"
            :href="getEnergyCSVURI"
            target="_blank"
            :download="`${getSelectedRegion} Energy Data.csv`"
            >
            {{ getSelectedRegion }} Energy Data
         </a>
         <span v-else>Download Municipal Energy Data</span>
      </el-menu-item>
   </el-submenu>
</template>

<script>
import { Submenu, MenuItem } from 'element-ui';

import { mapGetters } from 'vuex';
export default {
   components: {
      'el-submenu': Submenu,
      'el-menu-item': MenuItem,
   },
   computed: {
      ...mapGetters(['isDashboardMode']),
      ...mapGetters('infographics', ['getSelectedRegion', 'getEnergyCSVURI']),
   },
}
</script>

<style>

</style>
